(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace",
            {
                url: "/MarketPlace",
                component: "marketplace",
                PageTitle: "Marketplace"
            });
        }
    ]);

    app.component("marketplace",
    {
        templateUrl: "App/Tools/MarketPlace/MarketPlace.html",
        controller: marketPlaceCtrl
    });  

    marketPlaceCtrl.$inject = ["$mdDialog", "$state"];

    function marketPlaceCtrl() {

    }

})(window.app); // jshint ignore:line